var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.233,
    height: 15.305,
    viewBox: "0 0 16.233 15.305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chart-dots",
    "data-name": "Icon metro-chart-dots",
    d: "M3.484,16.32H16.876v1.913H1.571V2.928H3.484ZM6.8,14.436a1.435,1.435,0,0,1,0-2.87c.042,0,.084,0,.125.006L8.471,9a1.435,1.435,0,1,1,2.4,0l1.542,2.571q.063-.006.125-.006c.032,0,.063,0,.095,0l2.546-4.456a1.435,1.435,0,1,1,1.185.626c-.032,0-.063,0-.095,0l-2.546,4.456a1.435,1.435,0,1,1-2.387.026L9.8,9.647c-.041,0-.083.006-.125.006s-.084,0-.125-.006L8.005,12.218a1.435,1.435,0,0,1-1.2,2.218Z",
    transform: "translate(-1.571 -2.928)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/report_icon.98e4b7f190532563ce8c00a7d6a01653.svg";
export { ForwardRef as ReactComponent };